<div class="captcha-dialog">
  <mat-dialog-content class="!p-0">
    <header class="flex justify-between">
      <h2 class="text-2xl font-medium">Solve the puzzle</h2>
      <!-- Close dialog button -->
      <button mat-icon-button type="button" (click)="onCancelClick()" class="button-close ml-auto">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
        <span class="sr-only" i18n>Close</span>
      </button>
    </header>
    <div class="flex flex-row box-border place-content-center items-center">
      <div class="flex-1 box-border w-full">
        <div class="aws-captcha" thehubzAwsCaptcha (captchaSuccess)="captchaSuccess($event)"></div>
      </div>
    </div>
  </mat-dialog-content>
</div>
